import React, { useEffect, useState } from 'react';
import './NavigationPanel.css';

interface ReportItem {
  id: number;
  name: string;
  url: string;
}

interface ReportSectionProps {
  reportType: string;
  title: string;
  reports: ReportItem[];
}

const ReportSection: React.FC<ReportSectionProps> = ({ title, reports, reportType }) => {
  const storageKey = `report-section-${title.toLowerCase().replace(/\s+/g, '-')}`;
  const [isOpen, setIsOpen] = useState<boolean>(() => {
    const saved = localStorage.getItem(storageKey);
    return saved ? JSON.parse(saved) : false;
  });

  useEffect(() => {
    localStorage.setItem(storageKey, JSON.stringify(isOpen));
  }, [isOpen, storageKey]);

  function goToLegacyReport(rid: number, customURL: string | null) {

    const form = document.createElement('form');
    form.method = 'POST';
    form.action = customURL ?? '';
    form.target = '_self';

    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'rid';
    input.value = String(rid);

    form.appendChild(input);
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  }

  function goToPalantirReport(customURL: string) {
    window.location.href = customURL;
  }

  return (
    <div className="panel-section">
      <div className="panel-sectionHeader" onClick={() => setIsOpen(!isOpen)}>
        <span>{title}</span>
        <div className={`chevron ${isOpen ? 'down' : 'up'}`}></div>
      </div>
      {isOpen && (
        reports.length > 0 ? (
          <ul className="reportList">
            {reports.map((report) => (
              <li key={report.id} className="reportItem">
                {reportType === 'Favorites' ?
                  report.url.includes('.asp') ? (
                    <button
                      type="button"
                      className="link-button"
                      title={report.name}
                      onClick={() => goToLegacyReport(report.id, report.url)}
                    >
                      {report.name}
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="link-button"
                      title={report.name}
                      onClick={() => goToPalantirReport(report.url)}
                    >
                      {report.name}
                    </button>
                  )
                  :
                  <a
                    id={String(report.id)}
                    href={report.url}
                    title={report.name}>{report.name}</a>
                }
              </li>
            ))}
          </ul>
        ) : (
          <div className="emptyMessage">No reports available in this section.</div>
        )
      )}
    </div>
  );
};

export default ReportSection;
